jQuery(function($){

  $('html').removeClass('no-js'); 
  
  $('ul.styles > li').click(function(){
      var className = $(this).attr('class');
      $('body').removeClass('theme-style-0 theme-style-1 theme-style-2 theme-style-3');
      $('body').addClass(className);
    });

  $('li:last-child, .product-listing > div:last-child').addClass('lastItem');
  $('li:first-child, .product-listing > div:first-child').addClass('firstItem');
  

  /* Legacy dropdown menu */
  if ($.fn.supersubs && $.fn.superfish && $('ul.sf-menu').length) {
    $('ul.sf-menu').supersubs({
        minWidth: 12,
        maxWidth: 27,
        extraWidth: 1
      }).superfish({
        animation: { height: 'show' },
        speed: 'fast'
    });
  }

  if ($.fn.mobileMenu && $('.sf-menu').length) {
    $('.sf-menu').mobileMenu();
  }

  var ismobile = navigator.userAgent.match(/(iPhone)|(iPod)|(android)|(webOS)/i);
  if (ismobile && $.fn.sftouchscreen && $('.sf-menu').length) {
    $('.sf-menu').sftouchscreen();
  }


  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  }); 
 
   
   /*Form styles*/  
  $('.address_table form, .customer_address form').addClass('form-horizontal');


  /*Social icons*/

  $('.template-customers-login').find('.errors').addClass('alert').addClass('alert-danger');

  var promoMessages = [
    '<strong>Bundle-only protocols</strong> Find your ideal stack. <a href="/collections/all">Shop now</a>',
    '<strong>Free U.S. shipping</strong> On complete protocol bundles. <a href="/collections/all">Build yours</a>',
    '<strong>Sleep, focus, recovery</strong> Curated routines for high-output days. <a href="/collections/all">Explore</a>'
  ];

  $('.promo-bar').each(function(){
    var $bar = $(this);
    var $message = $bar.find('p');
    var $buttons = $bar.find('button');
    var current = 0;
    var timer;

    if ($buttons.length < 2) return;

    function showPromo(index){
      current = (index + promoMessages.length) % promoMessages.length;
      $message.fadeOut(120, function(){
        $message.html(promoMessages[current]).fadeIn(120);
      });
    }

    function startPromoRotation(){
      clearInterval(timer);
      timer = setInterval(function(){
        showPromo(current + 1);
      }, 4200);
    }

    $buttons.eq(0).on('click', function(){
      showPromo(current - 1);
      startPromoRotation();
    });

    $buttons.eq(1).on('click', function(){
      showPromo(current + 1);
      startPromoRotation();
    });

    startPromoRotation();
  });

  $('.protocol-compare').each(function(){
    var $section = $(this);
    var $quiz = $section.find('.protocol-quiz');

    $section.find('.quiz-open').on('click', function(){
      $quiz.removeAttr('hidden');
    });

    $section.find('.protocol-quiz__close').on('click', function(){
      $quiz.attr('hidden', 'hidden');
    });

    $quiz.on('click', function(event){
      if (event.target === this) {
        $quiz.attr('hidden', 'hidden');
      }
    });
  });



});
